<!--用户组-->
<template>
  <div class="hbn-container">
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            :model="Query"
            label-width="80px"
            label-position="top"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="代码">
                  <el-input
                    v-model="Query.UserGroupCode"
                    placeholder="代码"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="名称">
                  <el-input
                    v-model="Query.UserGroupName"
                    placeholder="名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <div style="padding-top: 28px">
            <el-button
              size="mini"
              class="hbn-button-serach"
              @click="SearchUserGroupInfo"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="hbn-table-screen">
      <div class="operation">
        <el-button class="custom-button" type="primary" @click="AddOpt">
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button>
        <el-button type="primary" class="custom-button" @click="importExcel">
          <i class="el-icon-upload custom-icon"></i>
          <span>导入</span>
        </el-button>
        <el-button type="primary" class="custom-button" @click="export2Excel">
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
      </div>
      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            v-loading="pageData.loading"
            :data="pageData.tabledatas"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :column-config="{ resizable: true }"
            :row-config="{ isHover: true }"
            :checkbox-config="{ highlight: true, range: true }"
            :highlight-current-row="true"
            @current-change="currentChangeEvent"
            @checkbox-all="selectAllChangeEvent"
            @checkbox-change="handleSelectionChange"
            @cell-dblclick="dblclick"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>
            <template v-for="(item, key) in columns" :key="key">
              <vxe-table-column
                :field="item.field"
                :title="item.name"
                :width="item.width"
                align="center"
                show-overflow-tooltip
                :sortable="item.order"
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
                v-if="item.ishide"
              />
            </template>
            <vxe-table-column
              width="150"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ row, rowIndex }">
                <el-button
                  type="text"
                  size="small"
                  @click="EditOpt(row, rowIndex)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="ViewOpt(row, rowIndex)"
                  >查看</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="DelOpt(row, rowIndex)"
                  >删除</el-button
                >
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="pageData.currentPage"
            :page-size="pageData.currentSize"
            :page-sizes="pageData.pagesizes"
            :total="pageData.total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
            <template #left>
              <span class="page-left">
                <span>已选中 {{ checkendSum }}</span>
                <span class="clear" @click.prevent="clearRecords">清空</span>
              </span>
            </template>
          </vxe-pager>
        </div>
      </div>
    </div>
    <usergroupEidt
      ref="Editdialog"
      @close-dialog="closeEditdialog"
    ></usergroupEidt>
    <excel
      importurl="/api/UserGroup/UploadFileAsync"
      fileName="用户组.xlsx"
      :dialogVisible="UpLoaddialogVisible"
      @close-dialog="closeDialog"
      @error="error"
      @success="success"
    ></excel>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, toRefs, onMounted, watch } from "vue";
import { GetUserGroupInfo, DeleteUserGroup } from "@api/usergroup";
import usergroupEidt from "@comp/UserInfo/usergroupEidt.vue";
import { ElMessageBox, ElMessage } from "element-plus";
// import XEUtils from "xe-utils";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
import { dateFormat } from "@/util/utils.js";

export default defineComponent({
  components: { usergroupEidt, excel },

  setup(props, ctx) {
    let data = reactive({
      columns: [
        {
          field: "id",
          name: "代码",
          width: 100,
          format: "",
          order: true,
          ishide: false,
        },
        {
          field: "UserGroupCode",
          name: "代码",
          width: 100,
          format: "",
          order: true,
          ishide: true,
        },
        {
          field: "UserGroupName",
          name: "名称",
          width: 100,
          format: "",
          order: true,
          ishide: true,
        },
        {
          field: "BZ",
          name: "备注",
          width: 100,
          format: "",
          order: false,
          ishide: true,
        },
        {
          field: "UpdateUser",
          name: "修改人",
          width: 100,
          format: "",
          order: false,
          ishide: true,
        },
        {
          field: "UpdateTime",
          name: "修改时间",
          width: 150,
          format: "datetime",
          order: true,
          ishide: true,
        },
      ], //数据列
      currentRow: null,
      multipleSelection: [],
      checkendSum: 0,
      Query: {
        UserGroupCode: "",
        UserGroupName: "",
      },
      show: false,
      UpLoaddialogVisible: false,
    });
    //分页对象
    let pageData = reactive({
      loading: false,
      tabledatas: [],
      currentPage: 1,
      currentSize: 20,
      pagesizes: [20, 50, 100, 500],
      total: 0,
      conditions: [],
      orderbyCloums: "CodeID",
    });
    let Editdialog = ref(null);
    let multipleTable = ref(null);
    const currentChangeEvent = ({ row, rowIndex }) => {
      data.currentRow = row;
    };
    const dblclick = ({ row, rowIndex }) => {
      ViewOpt(row, rowIndex);
    };
    const selectAllChangeEvent = ({ checked, records }) => {
      data.multipleSelection = records;
      data.checkendSum = records.length;
    };
    const handleSelectionChange = ({ records }) => {
      data.multipleSelection = records;
      data.checkendSum = records.length;
    };
    const handlePageChange = ({ currentPage, pageSize }) => {
      if (pageData.currentSize != pageSize) {
        pageData.currentPage = 1; //说明更改了每页展示条数，要从第一页进行展示
        pageData.currentSize = pageSize;
      } else {
        pageData.currentPage = currentPage;
      }
      SearchOpt();
    };
    //清空
    const clearRecords = () => {
      multipleTable.value.clearCheckboxRow();
      data.checkendSum = 0;
    };
    const formatterData = ({ cellValue, row, column }) => {
      let head = JSON.parse(column.className);
      let format = head.format;
      if (format == "datetime") {
        cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
      }
      return cellValue;
    };
    const importExcel = () => {
      data.UpLoaddialogVisible = true;
    };
    //弹出框事件
    function closeDialog(val) {
      data.UpLoaddialogVisible = false;
    }
    const error = () => {
      SearchOpt();
    };
    const success = () => {
      SearchOpt();
    };
    const export2Excel = () => {
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

        const tHeader = [
          ...Enumerable.from(data.columns)
            .select((item) => {
              return item.name;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(data.columns)
            .select((item) => {
              return item.field;
            })
            .toArray(),
        ]; // 导出的字段名
        let list = pageData.tabledatas;
        if (data.multipleSelection.length >= 1) {
          list = data.multipleSelection;
        }
        const exceldata = formatJson(filterVal, list);
        export_json_to_excel(tHeader, exceldata, `用户组`);
      });
    };
    function formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    }
    //新增
    function AddOpt() {
      Editdialog.value.initDialog("insert");
    }
    //修改
    function EditOpt(row, rowIndex) {
      Editdialog.value.initDialog("update", row);
    }
    //查看
    function ViewOpt(row, rowIndex) {
      Editdialog.value.initDialog("view", row);
    }
    function closeEditdialog() {
      SearchOpt();
    }
    //删除
    function DelOpt(row, rowIndex) {
      ElMessageBox.confirm(
        `您确认删除当前用户组[${row.UserGroupName}]？`,
        "提示",
        {
          cancelButtonClass: "cancelstyle",
          confirmButtonClass: "confirmstyle",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
        }
      ).then(() => {
        DeleteUserGroup(row)
          .then(() => {})
          .catch(({ mgessage }) => {
            ElMessage.error("删除失败!" + mgessage);
          });
      });
    }
    //查找
    function SearchUserGroupInfo() {
      SearchOpt();
    }
    //查询
    function SearchOpt() {
      pageData.loading = true;
      let PageQuery = {
        pageindex: pageData.currentPage,
        PageSize: pageData.currentSize,
        queryModel: {
          UserGroupCode: data.Query.UserGroupCode,
          UserGroupName: data.Query.UserGroupName,
        },
        orderbyCloums: pageData.orderbyCloums,
      };
      GetUserGroupInfo(PageQuery)
        .then(({ entities, totalCount }) => {
          pageData.tabledatas = entities;
          pageData.total = totalCount;
          pageData.loading = false;
        })
        .catch(({ mgessage }) => {
          pageData.loading = false;
          console.log("用户组查询失败", mgessage);
        });
    }
    //页面初始化
    onMounted(() => {
      SearchOpt();
    });
    return {
      ...toRefs(data),
      pageData,
      AddOpt,
      EditOpt,
      ViewOpt,
      DelOpt,
      SearchOpt,
      currentChangeEvent,
      selectAllChangeEvent,
      handleSelectionChange,
      handlePageChange,
      formatterData,
      Editdialog,
      closeEditdialog,
      dblclick,
      importExcel,
      export2Excel,
      closeDialog,
      error,
      success,
      SearchUserGroupInfo,
      multipleTable,
      clearRecords,
    };
  },
});
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #ffffff;
}
/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #f1f1f1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}
.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}
/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #ffffff;
}
.page-left {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}
.pagination {
  margin: 0;
  width: 100%;
  /* position: absolute;
        bottom: 0; */
  background-color: #fff;
  z-index: 7;
  padding: 5px 0;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
</style>
